import { render, staticRenderFns } from "./open-sum-record.vue?vue&type=template&id=44367f00&"
import script from "./open-sum-record.vue?vue&type=script&lang=js&"
export * from "./open-sum-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports